var React = require('react');

function Submit (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_2_1443)","key":0},React.createElement("path",{"d":"M23.6576 11.2L12.9846 0.342857C12.5564 -0.114286 11.843 -0.114286 11.3865 0.342857L10.6159 1.14286C10.1879 1.6 10.1879 2.31429 10.6159 2.77143L17.9785 10.2857H0.570749C0.256837 10.2857 0 10.5429 0 10.8571V13.1429C0 13.4571 0.256837 13.7143 0.570749 13.7143H18.0357L10.6445 21.2286C10.2164 21.6857 10.2164 22.4 10.6445 22.8571L11.4436 23.6571C11.8716 24.1143 12.585 24.1143 13.0416 23.6571L23.6576 12.8286C23.9144 12.5429 24 12.2857 24 12C23.9714 11.6286 23.9144 11.4857 23.6576 11.2Z","fill":"currentColor"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_2_1443"},React.createElement("rect",{"width":"24","height":"24","fill":"white"})))]);
}

Submit.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Submit;

Submit.default = Submit;
